/**
 * Animated SVG icons for the Services section.
 * Each plays its animation on parent `.group:hover`.
 */
const E = "#E5503A";

export function IconBars() {
  return (
    <svg viewBox="0 0 40 40" className="anim-bars" width="22" height="22" aria-hidden="true">
      <rect x="4"  y="6"  width="6" height="28" rx="1" fill={E} />
      <rect x="14" y="6"  width="6" height="28" rx="1" fill={E} />
      <rect x="24" y="6"  width="6" height="28" rx="1" fill={E} />
      <rect x="34" y="6"  width="4" height="28" rx="1" fill={E} />
    </svg>
  );
}

export function IconGear() {
  return (
    <svg viewBox="0 0 40 40" className="anim-gear" width="22" height="22" aria-hidden="true">
      <g fill="none" stroke={E} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="20" cy="20" r="5" />
        <path d="M20 4v4 M20 32v4 M4 20h4 M32 20h4 M8 8l3 3 M29 29l3 3 M32 8l-3 3 M11 29l-3 3" />
      </g>
    </svg>
  );
}

export function IconGrid() {
  return (
    <svg viewBox="0 0 40 40" className="anim-grid" width="22" height="22" aria-hidden="true">
      <rect x="4"  y="4"  width="14" height="14" rx="2" fill={E} />
      <rect x="22" y="4"  width="14" height="14" rx="2" fill={E} opacity="0.7" />
      <rect x="4"  y="22" width="14" height="14" rx="2" fill={E} opacity="0.7" />
      <rect x="22" y="22" width="14" height="14" rx="2" fill={E} />
    </svg>
  );
}

export function IconNeural() {
  return (
    <svg viewBox="0 0 40 40" className="anim-neural" width="22" height="22" aria-hidden="true">
      <g stroke={E} strokeWidth="1" opacity="0.55" fill="none">
        <line x1="8"  y1="10" x2="20" y2="20" />
        <line x1="8"  y1="30" x2="20" y2="20" />
        <line x1="32" y1="10" x2="20" y2="20" />
        <line x1="32" y1="30" x2="20" y2="20" />
      </g>
      <circle cx="20" cy="20" r="3"   fill={E} />
      <circle cx="8"  cy="10" r="2.2" fill={E} />
      <circle cx="8"  cy="30" r="2.2" fill={E} />
      <circle cx="32" cy="10" r="2.2" fill={E} />
      <circle cx="32" cy="30" r="2.2" fill={E} />
    </svg>
  );
}

export function IconPages() {
  return (
    <svg viewBox="0 0 40 40" className="anim-pages" width="22" height="22" aria-hidden="true">
      <rect x="10" y="8" width="20" height="26" rx="2" fill={E} opacity="0.55" />
      <rect x="10" y="8" width="20" height="26" rx="2" fill={E} opacity="0.8" />
      <rect x="10" y="8" width="20" height="26" rx="2" fill={E} />
    </svg>
  );
}

export const ANIM_ICONS = {
  Workflow:        IconBars,
  Zap:             IconGear,
  LayoutDashboard: IconGrid,
  Sparkles:        IconNeural,
  BookOpen:        IconPages,
};
